import { FC } from "react";
import { useLocation } from "react-router-dom";

import { LiveChatWidget as LiveChatWidgetBase } from "@livechat/widget-react";

import { config } from "config/config";
import { useHideChatWidgetOnWelcomeTutorial } from "hooks/use-hide-chat-widget-on-welcome-tutorial";

interface IProps {
  customerName: string;
  customerEmail: string;
}

export const LiveChatWidget: FC<IProps> = ({ customerName, customerEmail }) => {
  const { pathname } = useLocation();

  useHideChatWidgetOnWelcomeTutorial(pathname);

  return (
    <LiveChatWidgetBase
      license={config.livechatWidget.license}
      group={config.livechatWidget.group}
      customerName={customerName}
      customerEmail={customerEmail}
      chatBetweenGroups={false}
    />
  );
};
